document.addEventListener("DOMContentLoaded", () => {
  const link = document.querySelector('.cv-full-hero__link > span');
  if (!link) return;

  let hasScrolledDown = false;
  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY && !hasScrolledDown) {
      link.classList.add('scrolled');
      hasScrolledDown = true;
    } else if (currentScrollY < lastScrollY) {
      link.classList.remove('scrolled');
      hasScrolledDown = false;
    }

    lastScrollY = currentScrollY;
  };

  window.addEventListener('scroll', handleScroll);
});

